export default __webpack_public_path__ + "static/media/fm.5906b7c1.svg";